import React from "react";
import { Divider } from "../../../ecosystem";
import { PageHeading } from "../../../ecosystem/mybswh";

export const CareGapsHeading = ({
    heading,
    description,
    className
}) => {

    return (
        <div className="row care-gaps-heading-container">
            <div className="col-12">
                <PageHeading
                    heading={heading}
                    description={description}
                    bodyOffset
                    className={className}
                />
            </div>
        </div>
    );
};